import React, { Component } from 'react';
import styles from './style.module.css';
import Div100vh from 'react-div-100vh';

import Lightbox from 'react-lightbox-component';


class UberMich extends Component {



    render() {
        return (
            <sector id="ubermich" >

                <div className={styles.sectionWrapper}
                    style={{ minHeight: window.innerHeight }}>
                    <div className={styles.maxWidth + " revealClass"}>
                        <div className={styles.contentWrapper + " revealClass"}>
<div className={styles.person}>
    <div className={styles.media}>
      <div className={styles.evgeni} />
    </div>

    <div className={styles.copy}>
      <div className={styles.nameOverlay}>Evgeni</div>
      <p className={styles.smallText}>
Haare haben mich immer faszierniert. 2012 machte ich meine Leidenschaft zu meinem Beruf. Mein besonderes Interesse gilt der Farbe und Extensions. Diese Schwerpunkte habe ich immer wieder perfektioniert, jede neue Entwicklung verfolgt und ausprobiert. Zudem hatte ich das Glück meine Kreativität bei Farben und Schnitten bei Events präsentieren zu können. 2017 erreichte ich ein weiteres Ziel: Ich erwarb den Meistertitel. Und nun habe ich meinen ganz großen Traum verwirklicht: Mein eigenes Geschäft. An einem zauberhaften kleinen Platz im Glockenbachviertel, kann ich meine Begeisterung, Kreativität und Freude an Haaren verwirklichen.

Haare sollen faszinieren, sollen bewundert werden, sollen inspirieren. Haare sind ein Statement. Haare zeigen Stil. Haare sind ein Markenzeichen. Haare sind Persönlichkeit. Alles das würde ich gerne für Sie und mit Ihnen kreieren. 
      </p>
    </div>
</div>

  <div className={styles.person}>
    <div className={styles.media}>
      <div className={styles.ludovica} />
    </div>

    <div className={styles.copy}>
              <div className={styles.nameOverlay}>Ludovica</div>

      <p className={styles.smallText}>
        Kreativität trifft Präzision
        <br /><br />
Ludovica bringt italienisches Flair und Leidenschaft in unser Team. Als ausgewiesene Langhaar-Expertin versteht sie es, Haare in ihrer ganzen Länge und Schönheit perfekt in Szene zu setzen. Ihre besondere Leidenschaft gilt Balayage-Techniken, individuellen Farbkreationen sowie Haarverdichtung und Haarverlängerung – stets mit dem Ziel, natürliche, harmonische und dennoch ausdrucksstarke Ergebnisse zu erzielen. Mit einem feinen Gespür für Trends und einem hohen Anspruch an Qualität berät Ludovica ihre Kundinnen und Kunden ausführlich, um maßgeschneiderte Makeovers zu schaffen, die zur Persönlichkeit passen.
      </p>
    </div>
  </div>

                            {/* <div className={[styles.imageBios, "animate", "animateTop", "slowestTransition"].join(' ')}></div> */}

                        </div>

                    </div>
                </div >


            </sector>





        );
    }
}

export default UberMich;







